module.exports = __webpack_public_path__ + "static/media/043.0bca30d9.wav";


/*****************
 ** WEBPACK FOOTER
 ** ./src/sound/043.wav
 ** module id = 175
 ** module chunks = 0
 **/